import { ListItemButton as MUIListItemButton, styled } from '@mui/material'
import useGetListItemButtonTemplate
  from '~/src/components/mui-wrappers/styled/list-item-button/styles/useGetListItemButtonTemplate'

const ListItemButton = styled(MUIListItemButton)(() => useGetListItemButtonTemplate().getComponentSx())

export default ListItemButton
